import { get, post, patch, del, publicGet, publicPost } from './core';

export interface DirectorSummary {
  id: string;
  email: string;
  name: string;
  createdAt: string;
}

export function listDirectors(): Promise<DirectorSummary[]> {
  return get('/admin/directors');
}

// Story 063 sub-step 3 — invite a director by email + display name.
// Backend creates a director_invites row, sends the invite email with
// a /invite/:token link, and the accept handler propagates the name
// into the new user's director_profile so the tournament page's
// "Director: <name>" line works without manual profile setup.
export function inviteDirector(
  email: string,
  name: string,
  locale: string,
): Promise<{ id: string }> {
  return post('/admin/invites', { email, name, locale });
}

// Story 063 — update mutable fields on a director (currently just
// display name). Upserts the director_profiles row, so it works for
// directors who pre-date invite-flow profile seeding.
export function updateDirector(
  userId: string,
  input: { name?: string },
): Promise<DirectorSummary> {
  return patch(`/admin/directors/${userId}`, input);
}

// Story 063 sub-step 4 — remove a director. Backend rejects with 409
// when the user still owns non-completed tournaments.
export function removeDirector(userId: string): Promise<void> {
  return del(`/admin/directors/${userId}`);
}

// Public — no auth header. The invitee doesn't have a session yet.
export function previewDirectorInvite(
  token: string,
): Promise<{ email: string; name: string }> {
  return publicGet(`/director-invite/${token}`);
}

export function acceptDirectorInvite(
  token: string,
  password: string,
): Promise<{ userId: string; email: string }> {
  return publicPost(`/director-invite/${token}/accept`, { password });
}
